<template>
  <div class="tabs">
    <OverlayLoading :isLoading="loading" />
    <ul class="nav nav-tabs nav-justified">
      <li class="nav-item">
        <a class="nav-link active" :data-bs-target="`#language-settings`" :href="`#language-settings`"
          data-bs-toggle="tab">Language
          <span v-if="this.error_translation_tab"><span class="tab_error">Errors(*)</span></span>

        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :data-bs-target="`#general-settings`" :href="`#general-settings`" data-bs-toggle="tab">General
          Settings
          <span v-if="this.error_general_tab"><span class="tab_error">Errors(*)</span></span>
                   
        
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :data-bs-target="`#theme-settings`" :href="`#theme-settings`" data-bs-toggle="tab">Theme
          Settings</a>
      </li>
      <li class="nav-item">
          <a class="nav-link" :data-bs-target="`#three-dmodels`" :href="`#three-dmodels`" data-bs-toggle="tab">3D Assets</a>
      </li>
      <li class="nav-item">
                <a class="nav-link" :data-bs-target="`#match-making`" :href="`#match-making`" data-bs-toggle="tab">Match Making</a>
        </li>
      

    </ul>
    <div class="tab-content">
      <div id="language-settings" class="tab-pane active">
        <div class="snippet general-event-config-snippet">
          <div class="form-group row">
            <div class="col-lg-6">
              <label>Language *</label>
              <v-select required :rules="requiredRule" name="language" class="" placeholder="Select language"
                label="language" @option:selected="updateLaguage" :options="languages"
                :modelValue="selectedLanguageKey" />
              <ValidationMessages :element="v$.item.translations" />

            </div>
            <div class="col-lg-6">
              <label>Title *</label>
              <div class="kt-input-icon">
                <input type="text" class="form-control" name="title" maxlength="200" placeholder="Enter language title"
                  :value="getLanguageTitle()" @input="updateLanguageTitle" />
              </div>
              <ValidationMessages :element="v$.item.translations" />

            </div>
            <div class="form-group row">
              <div class="col-lg-12">
                <label>Description *</label>
                <div class="kt-input-icon">
                  <textarea rows="3" class="form-control" name="description" placeholder="Enter language description"
                    :value="getLanguageDescription()" @input="updateLanguageDescription"></textarea>
                </div>
                <ValidationMessages :element="v$.item.screen_logo" />
                <span class="error">{{ err_screen_logo }}</span>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="general-settings" class="tab-pane">
        <div class="snippet general-event-config-snippet">

          <div class="form-group row">
              <div class="col-lg-8">
                            <label>Presenters(Add Max 5 Presenters)</label>
                            <div class="kt-input-icon">
                                <v-select placeholder="Select presenters"
                                    label="name" 
                                    :modelValue="item.presenters"
                                    :options="speakers" track-by="id" :reduce="(option) => option.id"
                                    @option:selected="UpdatePresenters" @option:deselected="RemovePresenters"
                                    :selectable="() => item.presenters.length <5"
                                     multiple
                                    persistent-hint />
                            </div>
                        </div>
            
          </div>
          <div class="form-group row">
            <div class="col-lg-6">
              <label>Start Time</label>
              <div class="input-daterange input-group">
                <span class="input-group-text">
                  <i class="fas fa-calendar-alt"></i>
                </span>
                <input type="datetime-local" class="form-control" 
                :min="getEventDatetime(eventDetail.start_date)" 
                :max="getEventDatetime(eventDetail.end_date)" 
                name="start_date" :value="getDatetime(item.start_time)"
                  @change="updateStartTime" />
                <span class="input-group-text rounded-0">from</span>
              </div>
              <ValidationMessages :element="v$.item.start_time" />

            </div>
            <div class="col-lg-6">
              <label class>End Time</label>
              <div class="input-daterange input-group">
                <span class="input-group-text">
                  <i class="fas fa-calendar-alt"></i>
                </span>
                <input 
                :min="getEventDatetime(eventDetail.start_date)" 
                :max="getEventDatetime(eventDetail.end_date)" 
                type="datetime-local" 
                class="form-control" 
                name="start_date" 
                :value="getDatetime(item.end_time)"
                  @change="updateEndTime" />
                <span class="input-group-text rounded-0">to</span>
              </div>
              <ValidationMessages :element="v$.item.end_time" />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-6">
              <label>Exhibitor</label>
            <!--  <v-select :clearable="true"  placeholder="Select Exhibitor" label="title"
                :options="exhibitorsList" track-by="id" @option:selected="updateExhibitor"
                :modelValue="getSelectedExhibitor(exhibitorsList, item.exhibitor)" />-->

                <select class="form-control" @change="updateExhibitor">
                    <option value="" >Select</option>
                    <option v-for="option in exhibitorsList" :value="option.id" :key="option.id"
                    :selected="(item.exhibitor == option.id)">
                    {{ option.title }}
                    </option>
                </select>
            </div>
          </div>
          <div class="form-group row">
             <div class="col-lg-3">
                  <label>Has Sketch Room ?</label>
                  <br />
                  <div class="switch switch-sm switch-primary">
                      <input-switch name="is_rating" :value="item.hasSketchRoom" id="customSwitchesEx"
                          class="custom-control-input" @change="UpdateHasSketchRoom" />

                  </div>
               </div>
            <div class="col-lg-3">
              <label>Enable Rating ?</label>
              <br />
              <div class="switch switch-sm switch-primary">
                <input-switch name="is_rating" :value="item.is_rating" id="customSwitchesEx" class="custom-control-input"
                  @change="UpdateIsRating" />
              </div>
            </div>
            <div class="col-lg-3">
              <label>Screen Sharing ?</label>
              <br />
              <div class="switch switch-sm switch-primary">
                <input-switch name="is_screen_sharing" :value="item.is_screen_sharing" id="customSwitchesEx"
                  class="custom-control-input" @change="UpdateIsScreenSharing" />
              </div>
            </div>
            <div class="col-lg-3">
              <label>Schedule Status?</label>
              <br />
              <div class="switch switch-sm switch-primary">
                <input-switch name="is_schedule_status" :value="item.is_schedule_status" id="customSwitchesEx"
                  class="custom-control-input" @change="UpdateScheduleStatus" />
                   <span>{{item.is_schedule_status?"On":"Off"}}</span>
                  
              </div>
            </div>
          </div>
         
   
          <div class="form-group row">
                            <div class="col-lg-2">
                                <label>Skybox</label>
                                <br />
                                <div class="custom-control custom-switch">
                                <input-switch name="skybox_is_custom" :value="item.skybox_is_custom" id="customSwitchesEx" class="custom-control-input" @change="updateSkybox_is_custom" />
                                    <label
                                    class="custom-control-label"
                                    for="customEF"
                                    >{{item.skybox_is_custom ? 'Custom' : 'Pre Defined'}}</label>
                                </div>
                            </div>



                            <div class="col-lg-4" v-show="item.skybox_is_custom" >

                                <DropFiles :file="item.skybox_picture" 
                                            :module_id="this.moduleId" 
                                            dimmention="4096X4096"
                                            @onUploaded="updateSkyboxPicture" 
                                            @onRemoved="removeSkyboxPicture"
                                            :accept="'image/jpeg'"
                                            module_type="demo-space" 
                                            asset_type="skybox_picture"  
                                            @onError="errCb">

                                <template #header>
                                    <label>Sky box Picture (Size should be 4096x4096 pixel and format JPG.)</label>
                                </template>
                                <template #tooltip>
                                    <VTooltip style="display:inline-block">
                                    <i class="fa fa-info-circle" style="font-size:16px"></i>
                                    <template #popper>
                                        <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                                    </template>
                                    </VTooltip>
                                </template>
                                </DropFiles>
                                
                            </div>
                            <div class="form-group col-lg-4" v-show="!item.skybox_is_custom">
                                <label class>Sky Box:</label>
                                <div>
                                <select class="form-control" @change="updateSkybox">
                                <option value="" selected>Select</option>
                                <option v-for="option in skyboxes" :value="option.id" :key="option.id"
                                    :selected="(item.skybox == option.id)">
                                    {{ option.title }}
                                </option>
                                </select>

                                
                                </div>
                            </div>
                    </div>

                    <div class="form-group row" >
                    <div class="col-lg-2">
                        <label>Environment</label>
                        <br />
                        <input-switch name="environment_is_custom" :value="item.environment_is_custom" id="customSwitchesEx" class="custom-control-input" @change="updateEnvironment_is_custom" />
                        
                        
                            <label
                            class="custom-control-label"
                            for="customEG"
                            >{{item.environment_is_custom ? 'Custom' : 'Pre Defined'}}</label>
                        
                    </div>



                    <div class="col-lg-4" v-show="item.environment_is_custom">

                        <DropFiles :file="item.environment_picture" 
                                    :module_id="this.moduleId" 
                                    dimmention="6000X1113"
                                    @onUploaded="updateEnvironmentPicture" 
                                    @onRemoved="removeEnvironmentPicture"
                                    :accept="'image/png'"
                                    module_type="demo-space" 
                                    asset_type="environment_picture"  
                                    @onError="errCb">

                        <template #header>
                            <label>Environment Picture (Size should be 6000x1113 pixel and format PNG.)</label>
                        </template>
                        <template #tooltip>
                            <VTooltip style="display:inline-block">
                            <i class="fa fa-info-circle" style="font-size:16px"></i>
                            <template #popper>
                                <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                            </template>
                            </VTooltip>
                        </template>
                        </DropFiles>
                    
                    </div>

                    <div class="form-group col-lg-4" v-show="!item.environment_is_custom">
                        <label class>Environment:</label>
                        <div>

                            <select class="form-control" @change="updateEnvironment">
                        <option value="" selected>Select</option>
                        <option v-for="option in environments" :value="option.id" :key="option.id"
                            :selected="(item.environment == option.id)">
                            {{ option.title }}
                        </option>
                        </select>

                        
                        </div>
                    </div>
                </div>


          <div class="form-group row">
            <div class="col-lg-6">
              <DropFiles :file="validate_file(item.presentation_video)" accept="video/mp4" :module_id="item._id"
                module_type="demo-space" :dimmention="null" @onUploaded="updateVideo" @onRemoved="removeVideo"
                asset_type="presentation_video" @onError="errCb">
                <template #header>
                  <label>Presentation Video (Max size 500MB and format mp4.)</label>
                </template>
                <template #tooltip>
                  <VTooltip style="display:inline-block">
                    <i class="fa fa-info-circle" style="font-size:16px"></i>
                    <template #popper>
                      <img src="/admin_assets/img/event_garden_smallbanner_5.png" />
                    </template>
                  </VTooltip>
                </template>
              </DropFiles>
            </div>
            <div class="col-lg-6">
              <div class="containter eventhall_flags">
                  <div class="form-group row">
                      <label class>Presentation Documents:</label>
                      <div class="col-lg-12">

                          <div id ="multiple_images">
                              <input
                                  placeholder="Upload Multiple Documents"
                                  type="file"
                                  class="form-control"
                                  @change="updateDocuments"
                                  multiple="multiple"
                                  accept="application/pdf"
                                  
                              />
                              <p> (Should be in PDF format)</p>
                          </div>
              
                      </div>
                          <div class="image-list">
                                  <div class="image-item" v-for="file in item.presentation_documents" v-bind:key="file">
                                      <div class="image-details">
                                          <span class="image-name">{{getFileName(file.key)}}</span>
                                          <button type="button" class="remove-btn" @click="removeDocumentAsset($event, file.key)">Remove</button>
                                      </div>
                                  </div>
                          </div>
                  </div>


              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-6">
              <DropFiles @onError="screenLogoErrCb" :file="validate_file(item.screen_logo)" accept="image/jpeg"
                :module_id="item._id" module_type="demo-space" dimmention="688X400" @onUploaded="updateScreenLogo"
                @onRemoved="removeScreenLogo" asset_type="screen_logo">
                <template #header>
                  <label>Screen Logo *(Size should be 688x400 pixel and format jpg.)</label>
                </template>
                <template #tooltip>
                  <VTooltip style="display:inline-block">
                    <i class="fa fa-info-circle" style="font-size:16px"></i>
                    <template #popper>
                      <img src="/admin_assets/img/event_garden_smallbanner_5.png" />
                    </template>
                  </VTooltip>
                </template>
              </DropFiles>
              <div class="validation-error" v-if="v$.item.screen_logo.required.$invalid">
                <p class="alert alert-danger">{{ v$.item.screen_logo.required.$message }}</p>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div id="theme-settings" class="tab-pane">
        <div class="row">
          <div class="tabs tabs-vertical tabs-left">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item active" role="presentation">
                <a class="nav-link active" :data-bs-target="`#theme_content`" :href="`#theme_content`"
                  data-bs-toggle="tab">Theme Contents</a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="theme_content" class="tab-pane active show" role="tabpanel">
                <div class="snippet general-event-config-snippet">
             
                  <div class="form-group row">
                      <div class="containter eventhall_flags">
                            <div class="form-group row">
                                <label class>Long Banners:</label>
                                <div class="col-lg-12">

                                    <div id ="multiple_images">
                                        <input
                                            placeholder="Upload Multiple Documents"
                                            type="file"
                                            class="form-control"
                                            @change="updateVerticalBanner"
                                            multiple="multiple"
                                            accept="image/*"
                                            
                                        />
                                        <span>Upload Multiple Long Banners (Max Limit 10 & Suggested Resolution:360x900) </span>
                                      
                                    </div>
                        
                                </div>
                                    <div class="image-list">
                                            <div class="image-item" v-for="file in item.vertical_banners" v-bind:key="file">
                                                <img :src="IMAGE_URL + file.key" alt="Image 1" >
                                                <div class="image-details">
                                                    <span class="image-name">{{getFileName(file.key)}}</span>
                                                    <button type="button" class="remove-btn" @click="removeVerticalBannerAsset($event, file.key)">Remove</button>
                                                </div>
                                            </div>
                                    </div>
                            </div>
                        </div>
                                    
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div id="interpretify-settings" class="tab-pane">
        <div class="snippet general-event-config-snippet">
          <div class="form-group row">
            <div class="col-lg-4">
              <label>Enable "Interprefy" Interpretation</label>
              <br />
              <div class="switch switch-sm switch-primary">
                <input-switch name="interprefy" :value="item.interprefy" id="customSwitchesEx"
                  class="custom-control-input" @change="updateInterprefy" />
              </div>
            </div>
            <div class="col-lg-6">
              <label>Interprefy token</label>
              <div class="kt-input-icon">
                <input type="text" class="form-control" name="title" maxlength="200" placeholder="Enter event Interprefy Token"
                  :disabled="item.interprefy?false:true" 
                  @change="updateInterprefyToken"
                  :value="item.interprefy_token" />
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-4">
              <label>Enable "AWS" Interpretation</label>
              <br />
              <div class="switch switch-sm switch-primary">
                <input-switch name="interprefy" :value="item.aws_interpretation" id="customSwitchesEx"
                  class="custom-control-input" @change="updateAwsInterpretation" />
              </div>
            </div>
            <div class="col-lg-4">
              <label>Enable "Speech to Speech"</label>
              <div class="kt-input-icon">
                <input-switch name="speech_to_speech" :value="item.aws_enable_speech_to_speech" id="enableSpeechToSpeech"
                  class="custom-control-input" @change="updateAwsEnableSpeechToSpeech"
                  :styleDisable="this.aws_interprefy_disabled" />
              </div>
            </div>
            <div class="col-lg-4">
              <label>Enable "Speech to Text"</label>
              <div class="kt-input-icon">
                <input-switch name="speech_to_text" :value="item.aws_enable_speech_to_text" id="enableSpeechToText"
                  class="custom-control-input" @change="updateAwsEnableSpeechToText"
                  :styleDisable="this.aws_interprefy_disabled" />
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-4">
              <label>Enable "Chat" Interpretation</label>
              <br />
              <div class="switch switch-sm switch-primary">
                <input-switch name="interprefy" :value="item.chat" id="customSwitchesEx" class="custom-control-input"
                  @change="updateChat" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :id="`three-dmodels`" class="tab-pane">
    <div class="snippet general-event-config-snippet">
        <div class="form-group row">
            <div class="containter eventhall_flags">
                <div class="form-group row">
                    <label class>3D Models & Icons:</label>
                    
                    <!-- Add New Model-Icon Set Button -->
                    <div class="col-lg-12 mb-3">
                        <button 
                            type="button" 
                            class="btn btn-primary"
                            @click="addNewModelSet"
                            :disabled="isUploadingModels"
                        >
                            <i class="fas fa-plus"></i> Add New Model & Icon
                        </button>
                        <small class="text-muted ml-2">You can add multiple 3D models with corresponding icons</small>
                    </div>
                    
                    <!-- Model Sets Container -->
                    <div class="col-lg-12">
                        <div class="model-sets-container">
                            <div 
                                v-for="(modelSet, index) in item.modelSets" 
                                :key="index"
                                class="model-set-card"
                            >
                                <div class="card mb-4">
                                    <div class="card-header bg-light d-flex justify-content-between align-items-center">
                                        <h6 class="mb-0">Model Set #{{ index + 1 }}</h6>
                                        
                                    </div>
                                    <div class="card-body">
                                        <!-- Model Upload -->
                                        <div class="row mb-3">
                                            <div class="col-md-6">
                                                <label>3D Model (FBX format):</label>
                                                <div class="upload-container">
                                                    <input 
                                                        type="file" 
                                                        class="form-control"
                                                        @change="(e) => updateModelFile(e, index)"
                                                        :disabled="isUploadingModels"
                                                        accept=".fbx"
                                                    />
                                                    <small class="text-muted">Max size: 10MB, FBX format only</small>
                                                    
                                                    <!-- Model Info -->
                                                    <div v-if="modelSet.model" class="mt-2">
                                                        <div class="file-info alert alert-sm alert-info mb-2">

                                                            <div><strong>Model:</strong>
                                                              <a :href="IMAGE_URL + modelSet.model.key" target="_blank">
                                                              {{ getFileName(modelSet.model.key) }}</a></div>
                                                            <div><strong>Size:</strong> {{ formatBytes(modelSet.model.size) }}</div>
                                                        </div>
                                                        <button 
                                                            v-if="modelSet.model"
                                                            type="button" 
                                                            class="btn btn-sm btn-danger"
                                                            @click="removeModelFile(index)"
                                                        >
                                                            Remove Model
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <!-- Icon Upload -->
                                            <div class="col-md-6">
                                                <label>Icon Image:</label>
                                                <div class="upload-container">
                                                    <input 
                                                        type="file" 
                                                        class="form-control"
                                                        @change="(e) => updateIconFile(e, index)"
                                                        :disabled="isUploadingModels"
                                                        accept="image/*"
                                                    />
                                                    <small class="text-muted">Suggested: 100x100 pixels, PNG/JPG format</small>
                                                    
                                                    <!-- Icon Preview -->
                                                    <div v-if="modelSet.icon" class="mt-2">
                                                        <div class="file-info alert alert-sm alert-info mb-2">
                                                            <div class="d-flex align-items-center">
                                                                <img 
                                                                    :src="IMAGE_URL + modelSet.icon.key" 
                                                                    alt="Icon preview"
                                                                    class="icon-preview mr-2"
                                                                >
                                                                <div>
                                                                    <div><strong>Icon:</strong> {{ getFileName(modelSet.icon.key) }}</div>
                                                                    <div><strong>Size:</strong> {{ formatBytes(modelSet.icon.size) }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button 
                                                            v-if="modelSet.icon"
                                                            type="button" 
                                                            class="btn btn-sm btn-danger"
                                                            @click="removeIconFile(index)"
                                                        >
                                                            Remove Icon
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Progress Bar Section -->
                    <div v-if="isUploadingModels" class="col-lg-12 mt-3">
                        <div class="card">
                            <div class="card-body">
                                <div class="progress" style="height: 25px;">
                                    <div 
                                        class="progress-bar progress-bar-striped progress-bar-animated" 
                                        :style="{ width: uploadProgress + '%' }" 
                                        role="progressbar"
                                        :aria-valuenow="uploadProgress" 
                                        aria-valuemin="0" 
                                        aria-valuemax="100"
                                    >
                                        {{ uploadProgress }}%
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <small class="text-muted">
                                        Uploading {{ currentUploadIndex + 1 }} of {{ totalFilesToUpload }} files...
                                        ({{ formatBytes(uploadedSize) }} / {{ formatBytes(totalSize) }})
                                    </small>
                                </div>
                                <div class="mt-2">
                                    <button 
                                        type="button" 
                                        class="btn btn-sm btn-danger" 
                                        @click="cancelUpload"
                                    >
                                        <i class="fas fa-stop-circle"></i> Cancel Upload
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Upload Summary -->
                    <div v-if="item.modelSets && item.modelSets.length > 0" class="col-lg-12 mt-3">
                        <div class="alert alert-success">
                            <h6><i class="fas fa-info-circle"></i> Upload Summary</h6>
                            <div><strong>Total Sets:</strong> {{ item.modelSets.length }}</div>
                            <div><strong>Models Uploaded:</strong> {{ getUploadedModelsCount() }}</div>
                            <div><strong>Icons Uploaded:</strong> {{ getUploadedIconsCount() }}</div>
                            <div><strong>Total Size:</strong> {{ formatBytes(getTotalModelsSize()) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
      </div>
       <div    :id ="'match-making'" class="tab-pane">
                      <MatchMakingTab
                            v-if="item && item._id"
                            ref="matchMakingTab"
                            :module-id="item._id"
                            :event-id="item.event_id"
                            module-name="Display-Center"
                            module-display-name="Display Center"
                            :max-tags="200"
                            :required="false"
                            :auto-save="false"
                            :show-save-button="true"
                            @saved="onMatchMakingSaved"
                        />
                </div>

  


      <div class="card-body text-right mt-3 mr-5">
        <button type="button" class="mb-1 mt-1 me-1 btn btn-lg btn-primary" @click="submitForm">Save</button>
        <button type="button" class="mb-1 mt-1 me-1 btn btn-lg btn-secondary" @click="cancelClick">Cancel</button>
      </div>
    </div>
    <FlashMessage group="demo_space_edit" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { upload , remove} from "@/services/FileUploader";
import { v4 as uuidv4 } from 'uuid';
import _ from "lodash";
import InputSwitch from "@/components/Commons/InputSwitch";
import ObjectID from 'bson-objectid';
import moment from 'moment';
import { gettingErrorMessage } from "@/services/GetValidationMessage";
import ValidationMessages from "@/components/Commons/Validations/ValidationMessages";
import {
  useVuelidate
} from '@vuelidate/core'
import {
  required,
  email,
} from '@vuelidate/validators'
const maxVideoFileSize = 524288000; // Max file size
const maxPdfFileSize =  32096088;  // Max file size
import constants from "@/config/constants";
import MatchMakingTab from "@/components/Commons/MatchMaking/MatchMakingTab.vue";

export default {
  name: 'RoundTableEditForm',
  data() {
    return {
      IMAGE_URL:constants.IMAGE_URL,
      changingVariable: 0,
      moduleId: ObjectID(),
      dialog: false,
      translation: [],
      languageKey: null,
      stream_disabled: true,
      restric_user_disabled: true,
      interprefy_disabled: true,
      aws_interprefy_disabled: true,
      chat_disabled: true,
      salutation: ['Mr', 'Ms', 'Mrs'],
      selected_salutation: null,
      exhibitorsList: [],
      selectedLanguage: null,
      error_translation_tab: false,
      error_general_tab: false,
      error_theme_tab: false,
      error_interpretation_tab: false,
      err_translations: null,
      err_speaker: null,
      err_exhibitor: null,
      err_start_time: null,
      err_end_time: null,
      err_is_restricted: false,
      err_minutes: null,
      err_is_rating: null,
      err_is_screen_sharing: null,
      err_is_live_streaming: null,
      err_stream_url: null,
      err_schedule_status: null,
      err_video: null,
      err_documents: null,
      err_screen_logo: null,
      err_sesssion_logo: null,
      err_is_background_picture: null,
      err_background_picture: null,
      err_background_color: null,
      err_background_color_bottom: null,
      err_banner_picutre: null,
      err_interprefy: null,
      err_interprefy_token: null,
      err_aws_interpretation: null,
      err_aws_enable_speech_to_speech: null,
      err_aws_enable_speech_to_text: null,
      err_chat: null,

      questionList: true,
      setIsSurveyEdit: false,
      isUploadingModels: false,
      uploadProgress: 0,
      currentUploadIndex: 0,
      totalFilesToUpload: 0,
      uploadedSize: 0,
      totalSize: 0,
      uploadCancelToken: null,

    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  validations() {
    return {
      item: {

        translations: {
          required
        },

       
        start_time: {
          required,
        },
        end_time: {
          required,
        },
        screen_logo: {
          required,
        }
      }
     
    };
  },

  props: {
    event: {
      type: Object
    },
    languages: {
      type: Array,
    },
    eventDetail:null
  },
  watch: {

    'newSpeaker.salutation': function (item) {

      if (item !== undefined) {
        this.selected_salutation = item;
      }
    },
    'exhibitors': function (items) {

      this.exhibitorsList = _.map(items, (item) => {

        const translate = _.get(_.head(item.translations), 'name');
        return {
          title: translate,
          id: item._id
        }
      })
    }
  },
  components: {
    InputSwitch,
    MatchMakingTab
    
  },
  computed: {

    
    ...mapGetters('DemoSpaceSingle', [
      'error_translation_tab',
      'error_general_tab',
      'item',
      'loading',
      'newSpeaker',
      'createSpeakerBtnTxt',
      'newEmailExists',
      'eventID',
      'createDialog',
      'listExhibitors',
      'selectedLanguageKey',
      'selectedLanguageTitle',
      'selectedLanguageDescirption',
      "skyboxes",
      "environments"
    ]),
    ...mapGetters('DemoSpaceIndex', ['speakers']),
    ...mapGetters('ExhibitorsIndex', { exhibitors: "all" }),
    ...mapGetters("EventsSingle", {"eventItem": "item"}),
    ...mapGetters('ConfigurationsSingle', {'projectConfiguration':'item'}),

   


  },
  beforeUnmount() {
    this.resetState()
    delete this.$flashMessage.groups.demo_space_edit;
  },
  created() {
    this.setSpeakerEventId(this.event.event_id);
    
    
  },
  mounted() {
    //this.fetchsurveydata(this.event._id); //questions data 
    this.updateTimeZone();
    this.setEventTd(this.item.event_id);
    this.fetchExhibitorsData(this.item.event_id);
    if(this.item.session_open){
      this.session_open_disabled = false;
   
    }
    this.fetchConfiguration();
    this.fetchEventData(this.$route.params.event_id);
    //this.setLocalTime();
   
    // this.setEventTd(this.event.event_id);
    //this.fetchData(this.item.event_id);

  },
  methods: {   

    ...mapActions("EventsSingle",{"fetchEventData":"fetchData"}),
    ...mapActions('ConfigurationsSingle', {'fetchConfiguration': 'fetchData'}),      
  
    ...mapActions('DemoSpaceIndex', {
      fetchAllData: 'fetchData',
    }),
    ...mapActions('DemoSpaceSingle', [
      'setLocalTime',
      'updateData',
      'storeSpeakerData',
      'storeData',
      'fetchData',
      'checkEmailExists',
      'resetState',
      'setTranslations',
      'setEventTd',
      'setSpeaker',
      'setSpeakerSalutation',
      'setSpeakerEmail',
      'setSpeakerEventId',
      'setSpeakerFirstName',
      'setSpeakerLastName',
      'setSpeakerCretedBy',
      'setExhibitor',
      'setIsRestricted',
      'setMinutes',
      'setIsRating',
      'setIsScreenSharing',
      'setIsLiveStreaming',
      'setStreamUrl',
      'setScheduleStatus',
      'setIsBackgroundPicture',
      'setPresentationVideo',
      'setPresentationDocuments',
      'setScreenLogo',
      'setSesssionLogo',
      'setBackgroundPicture',
      'setSpeakerPicutre',
      'setBackgroundColor',
      'setInterprefy',
      'setInterprefyToken',
      'setAwsInterpretation',
      'setAwsEnableSpeechToSpeech',
      'setAwsEnableSpeechToText',
      'setChat',
      'setStartTime',
      'setEndTime',
      'setCreatedBy',
      'setLangKey',
      'setLangTitle',
      'setLangDescirption',
      'setSessionOpen',
      'setMaxNoAttendees',
      'setAttendees',
      'setSesssionThemeLogo',
      'setBackgroundColorBottom',
      'setNotesArcColor',
      'setBanner',
      'setErrorTranslationTab',
      'setErrorGeneralTab',
      'setTimeZone',
      'setSkybox_is_custom',
      'setEnvironment_is_custom',
      'setSkyboxPicture',
      'setEnvironmentPicture',
      'setSkybox',
      'setEnvironment',
      'setDocument',
      'removeDocument',
      'setVerticalBanner',
      'removeVerticalBanner',
      'setModel1',
      'setModel2',
      'setModels',
      'removeModels',
      'addModelSet',
      'setModelSets',
      'addModelSet',
      'removeModelSet',
      'updateModelInSet',
      'updateIconInSet',
      'updateModelSetName',
      'setPresenters',
      'setHasSketchRoom'
      
    ]),
    ...mapActions('ExhibitorsIndex', { fetchExhibitorsData: "fetchData" }),
    formatBytes(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    getFileName(str){
      let stringNew =  str.split("/").pop();
      return stringNew.slice(-25);
    },
    getSelectedExhibitor(listExhibitors, exhibitorId) {
      const getSelectedExhibitor = _.find(listExhibitors, i => i.id === exhibitorId);
      return _.get(getSelectedExhibitor, 'title', '');
    },
    updateTimeZone(){
      this.setTimeZone(this.eventDetail.time_zone)
    },
    reRenderComponent() {
      this.changingVariable += 1
    },
    fileLoad(e) {
      const file = e.target.files[0];
      const id = uuidv4();
      upload(file, id, "users", null, file.type)
        .then((resp) => {
          console.log(resp)

        })
        .catch((e) => {
          console.error(e)
          this.$flashMessage.show({
            group: 'demo_space_edit',
            type: 'error',
            title: 'Error',
            text: 'Something went wrong.'
          });
        })
    },
    validate_file(fileInfo) {
      // console.log(fileInfo);
      if (_.has(fileInfo, 'key'))
        return fileInfo;
      return null;
    },
    updateSpeaker(value) {
      this.setSpeaker(value.id);
    },
    async submitSpeakerForm() {
      this.storeSpeakerData()
        .then(async () => {
          this.$flashMessage
                        .show({
                            group   : 'demo_space_edit',
                            type    : 'success',
                            title   : 'Success',
                            time    : 1000,
                            html    : '<ul><li>Speaker added successfully.</li></ul>',
                        });
                
          await this.fetchAllData(this.eventID);
          //this.resetState();
          this.dialog = false;
          this.setSpeakerFirstName(null);
          this.setSpeakerLastName(null);
        
        })
        .catch((error) => {
          console.log("submitSpeakerForm", error);
          let html = gettingErrorMessage(error);
          if (error.response.data.data.error) {
            this.$flashMessage.show({
              group: 'demo_space_edit',
              type: 'error',
              title: 'Failed',
              text: html || 'Something went wrong',
              html: html
            });
          }
        })
    },
    getSpeakerId(speaker) {
      return _.has(speaker, '_id') ? speaker._id : speaker;
    },
    async checkLanguageValidation() {
            let errorsArr = [];
            _.map(this.languages, (item) => {
                let langInfo = _.find(this.item.translations, { 'key': item });
                if (langInfo) {
                    if(langInfo.title == null){
                        errorsArr.push(`<li>${item}.title can not be empty.</li>`)
                    }
                    if(langInfo.description == null){
                        errorsArr.push(`<li>${item}.description can not be empty.</li>`)
                    }
                    if (langInfo.title!==null && langInfo.title.length < 3) {
                        errorsArr.push(`<li>${item}.title atleast 3 chracter long.</li>`)
                    }
                    if (langInfo.description!==null && langInfo.description.length < 10) {
                        errorsArr.push(`<li>${item}.description atleast 10 chracter long.</li>`)
                    }

                } else {
                    errorsArr.push(`<li>${item}.title can not be empty.</li>`)
                    errorsArr.push(`<li>${item}.description can not be empty.</li>`)
                }

            });
            return errorsArr;
    },
    async submitForm() {
      const isFormCorrect = await this.v$.$validate();
          let validateTranlation = await this.checkLanguageValidation();
          this.error_general_tab = false;
          this.error_translation_tab = false;
          this.error_theme_tab = false;
          this.error_interpretation_tab = false;
          this.setErrorGeneralTab(false)
          this.setErrorTranslationTab(false);

          let generalError = []; 
            _.map(this.v$.$errors, (item) => {
              
              if(item.$property == "start_time"){
                generalError.push("<li>Start Time is required</li>");
              }
              if(item.$property == "end_time"){
                generalError.push("<li>End Time is required</li>");
              }
              if(item.$property == "screen_logo"){
                generalError.push("<li>Screen Logo is required</li>");
              }
                
            });
            
            if(!_.isEmpty(validateTranlation) && !_.isEmpty(generalError)){
                this.error_general_tab = true;
                this.error_translation_tab = true;
                
                this.setErrorTranslationTab(true);
                this.setErrorGeneralTab(true);
                
            }

            if (!isFormCorrect || !_.isEmpty(validateTranlation) ) {
           
                if (!_.isEmpty(validateTranlation)) {
           
                  this.error_translation_tab = true;
                  this.setErrorTranslationTab(true);
                  this.$flashMessage.show({
                      group: 'demo_space_edit',
                      type: 'error',
                      time:1000,
                      title: 'Failed',
                      html: `<ul>${validateTranlation.join("")}</ul>`
                  });
                return ;
              }          
            } 
            if (!isFormCorrect ) {
                
                if (!_.isEmpty(generalError)) {
                this.error_general_tab = true;
                    this.setErrorGeneralTab(true);
                    this.$flashMessage.show({
                        group   : 'demo_space_edit',
                        type    : 'error',
                        time    : 1000,
                        title   : 'Validation Failed',
                        html    : `<ul>${generalError.join("")}</ul>`
                    });
                    return ;
                }
            }
       
      this.updateData()
        .then(async () => {

          this.$flashMessage.show({
            group : 'demo_space_index',
            type  : 'success',
            title : 'Success',
            time  : 1000,
            html  : '<ul><li>Demo Space has been updated successfully.</li></ul>'
          });

          await this.fetchAllData(this.item.event_id);
          this.resetState();
          this.dialog = false;
        })
        .catch((error) => {
          console.error("Error update roundtable", error)
          let html = gettingErrorMessage(error);

          this.$flashMessage.show({
            group: 'demo_space_edit',
            type: 'error',
            title: 'Error',
            text: html || 'Something went wrong.',
            html: html
          });
        })
    },
    updateLaguage(value) {

      this.err_translations = null;
      this.setLangKey(value);
      this.languageKey = value;
      this.setLangTitle(null);
      this.setLangDescirption(null);

      if (_.isUndefined(_.find(this.item.translations, {
        'key': value,
      }))) {
        let obj = {
          "key": `${value}`,
          "title": null,
          "description": null
        }
        this.item.translations.push(obj);
      } else {

        let selectedLang = _.find(this.item.translations, {
          'key': this.selectedLanguageKey,
        })
        if (!_.isUndefined(selectedLang)) {
          this.setLangTitle(selectedLang.title);
          this.setLangDescirption(selectedLang.description);
        }
      }

    },
    updateLanguageTitle(e) {
      this.err_translations = null;
      if (!_.isNull(this.selectedLanguageKey) && !_.isEmpty(this.selectedLanguageKey)) {
        this.setTranslations({
          key: this.selectedLanguageKey,
          update_key: 'title',
          update_value: e.target.value
        });

      }
      this.setLangTitle(e.target.value);
    },
    updateLanguageDescription(e) {
      if (!_.isNull(this.selectedLanguageKey) && !_.isEmpty(this.selectedLanguageKey)) {
        this.setTranslations({
          key: this.selectedLanguageKey,
          update_key: 'description',
          update_value: e.target.value
        });
      }
      this.setLangDescirption(e.target.value);
    },
    getLanguageTitle() {
      return this.selectedLanguageTitle;
    },
    getLanguageDescription() {
      return this.selectedLanguageDescirption;
    },
    updateNewSpeakerEmail(e) {
            // More comprehensive email regex
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            
            if (emailRegex.test(e.target.value.trim())) {
                this.setSpeakerEmail(e.target.value.trim());
                this.setSpeakerEventId(this.eventID);
                this.setSpeakerCretedBy("63da6ecb083ba9aebc3b35f5");
                this.checkEmailExists()
                    .then()
                    .catch((error) => {
                        console.error(error)
                        this.$flashMessage.show({
                            group: 'lp_create',
                            type: 'error',
                            title: 'Error',
                            text: 'Something went wrong.'
                        });
                    })
            } else {
                this.setSpeakerFirstName(null);
                this.setSpeakerLastName(null);
            }
    },

    updateNewSpeakerEmailX(e) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value)) {
        console.log("Email---", e.target.value, e);
        this.setSpeakerEmail(e.target.value);
        this.setSpeakerEventId(this.eventID);
        this.setSpeakerCretedBy("63da6ecb083ba9aebc3b35f5");
        this.checkEmailExists()
          .then()
          .catch((error) => {
            console.error(error)
            this.$flashMessage.show({
              group: 'demo_space_edit',
              type: 'error',
              title: 'Error',
              text: 'Something went wrong.'
            });
          })
      } else {
        this.setSpeakerFirstName(null);
        this.setSpeakerLastName(null);
      }
    },
    updateNewSpeakerSalutation(value) {
      this.setSpeakerSalutation(value);
    },
    updateNewSpeakerFirstName(e) {
      this.setSpeakerFirstName(e.target.value);
    },
    updateNewSpeakerLastName(e) {
      this.setSpeakerLastName(e.target.value);
    },
    updateExhibitor(e) {
      //this.setExhibitor(value.id);
      this.setExhibitor(e.target.value);
       
    },
    UpdateIsRestricted(e) {
      this.restric_user_disabled = true;
      if (e.target.checked) {
        this.restric_user_disabled = false;
      }

      this.setIsRestricted(e.target.checked);
    },
    UpdateQaType(e) {
      this.setQaType(e.target.checked);
    },
    UpdateIsRating(e) {
      this.setIsRating(e.target.checked);
    },
    UpdateIsScreenSharing(e) {
      this.setIsScreenSharing(e.target.checked);
    },
    UpdateIsLiveStreaming(e) {
      this.stream_disabled = true;
      if (e.target.checked) {
        this.stream_disabled = false;
      }
      this.setIsLiveStreaming(e.target.checked);
    },
    UpdateScheduleStatus(e) {
      this.setScheduleStatus(e.target.checked);
    },
    UpdateIsBackgroundPicture(e) {
      this.setIsBackgroundPicture(e.target.checked);
    },
    updateVideo(info, data) {
      if (!_.has(data, 'data.Key')) {
        return;
      }

      const extension = data.data.Key.split('.').pop();
      const key = _.get(this.item.presentation_video, 'Key', null);
      const size = _.get(info, 'file.size', 0);
      if(size>maxVideoFileSize){
        this.showCbError();
        return;
      }
      this.setPresentationVideo({
        old_key: key,
        key: data.data.Key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    removeVideo(e) {
      this.setPresentationVideo(null);
    },
    updateDocument(info, data) {
      //if (!_.has(data, 'data.key') || !_.has(data, 'data.Key')) {
        //return;
      //}
      const extension = data.data.key?data.data.key.split('.').pop():data.data.Key.split('.').pop();
      const key   = _.get(this.item.presentation_documents, 'key', null);
      const size  = _.get(info, 'file.size', 0);

      if(size>maxPdfFileSize){
        this.showCbError();
        return;
      }
      this.setPresentationDocuments({
        old_key   : data.data.key?data.data.key:data.data.Key,
        key       : data.data.key?data.data.key:data.data.Key,
        temp_key  : info.id,
        size      : size.toString(),
        extension : extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    /*removeDocument(e) {
      this.setPresentationDocuments(null);
    },*/
    updateScreenLogo(info, data) {
      this.err_screen_logo = null;
      if (!_.has(data, 'data.key')) {
        return;
      }

      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.screen_logo, 'key', null);
      const size = _.get(info, 'file.size', 0);

      this.setScreenLogo({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    removeScreenLogo(e) {
      this.err_screen_logo = null;
      this.setScreenLogo(null);
    },
    updateSesssionLogo(info, data) {
      // console.log(data);
      if (!_.has(data, 'data.key')) {

        return;
      }

      const extension = data.data.key.split('.').pop()
      const key = _.get(this.item.sesssion_logo, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setSesssionLogo({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    removeSesssionLogo(e) {
      this.setSesssionLogo(null);
    },
    updateSesssionThemeLogo(info, data) {
       console.log(data);
      if (!_.has(data, 'data.key')) {

        return;
      }

      const extension = data.data.key.split('.').pop()
      const key = _.get(this.item.sesssion_theme_logo, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setSesssionThemeLogo({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    removeSesssionThemeLogo(e) {
      this.setSesssionThemeLogo(null);
    },
    updateBackgroundPicture(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.background_picture, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setBackgroundPicture({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    removeBackgroundPicture(e) {
      this.setBackgroundPicture(null);
    },
    updateBannerPicutre(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }

      const extension = data.data.key.split('.').pop()
      const key = _.get(this.item.banner, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setBanner({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    removeBannerPicutre(e) {
      this.setBanner(null);
    },
    updateStreamUrl(e) {
      this.setStreamUrl(e.target.value);
    },
    updateMinutes(e) {
      this.setMinutes(e.target.value);
    },
    updateBackgroundColor(e) {
      this.setBackgroundColor(e.target.value);
    },
    updateBackgroundStripesColor(e) {
      this.setBackgroundStripesColor(e.target.value);
    },
    updateBackgroundColorBottom(e) {
      this.setBackgroundColorBottom(e.target.value);
    },
    updateNotesArcColor(e) {
      this.setNotesArcColor(e.target.value);
    },
    UpdatePresenters(e) {
      let attenArr = [];
      _.forEach(e, function (value) {
          attenArr.push(value.id)
      });
      this.setPresenters(attenArr);
           
                       
   },
    RemovePresenters(e) {
        let clonePresenters = _.cloneDeep(this.item.presenters);
        const index = clonePresenters.indexOf(e.id);
        if (index > -1) { // only splice array when item is found
            clonePresenters.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.setPresenters(clonePresenters);
    },
    updateInterprefy(e) {
      this.interprefy_disabled = true;
        if (e.target.checked) {
            this.interprefy_disabled = false;
            this.setAwsInterpretation(false)
            this.aws_interprefy_disabled =true;
            this.setAwsEnableSpeechToSpeech(false);
            this.setAwsEnableSpeechToText(false);
        }
        this.setInterprefy(e.target.checked);
        
    },
    updateInterprefyToken(e) {
      this.setInterprefyToken(e.target.value);
    },
    updateAwsInterpretation(e) {
      this.aws_interprefy_disabled = true;
      if (e.target.checked) {
          this.aws_interprefy_disabled = false;
      }
      if(e.target.checked){
        this.setInterprefy(false);
        this.interprefy_disabled= true
      }
      //interprefy
      this.setAwsInterpretation(e.target.checked);
    },
    updateAwsEnableSpeechToSpeech(e) {
      this.setAwsEnableSpeechToSpeech(e.target.checked);
    },
    updateAwsEnableSpeechToText(e) {
      this.setAwsEnableSpeechToText(e.target.checked);
    },
    updateChat(e) {
      this.setChat(e.target.checked);
    },
    getDatetime(datetime) {
      //return moment(datetime).utc().format('YYYY-MM-DD HH:mm:ss');
      //return moment(datetime).format('YYYY-MM-DD HH:mm:ss');
      return moment(datetime).format('YYYY-MM-DD HH:mm:ss');
        
     // return moment.utc(datetime).tz(this.eventDetail.time_zone).format('YYYY-MM-DD HH:mm:ss')
      

    },
    updateStartTime(e) {
      this.setStartTime(e.target.value);
    },
    updateEndTime(e) {
      this.setEndTime(e.target.value);
    },
    cancelClick() {
      this.resetState()
    },
    errCb(e) {
      this.$flashMessage.show({
        group : 'demo_space_edit',
        type  : 'error',
        title : 'Failed',
        html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
      });

    },
    UpdateSessionOpen(e) {
      this.session_open_disabled = true;
      if (e.target.checked) {
        this.session_open_disabled = false;
      }
      this.setSessionOpen(e.target.checked);
    },
    UpdateMaxNoAttendees(e) {
      this.setMaxNoAttendees(e.target.value);
    },
    UpdateAttendees(e) {
      let attenArr = [];
      _.forEach(e, function (value) {
        attenArr.push(value.id)
      });

      this.setAttendees(attenArr);
    },
      RemoveAttendees(e) {
        let cloneAttendees = _.cloneDeep(this.item.attendees);
        const index = cloneAttendees.indexOf(e.id);
        if (index > -1) { // only splice array when item is found
          cloneAttendees.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.setAttendees(cloneAttendees);
      },
      showCbError() {
        this.$flashMessage.show({
          group : 'demo_space_edit',
          type  : 'error',
          title : 'Failed',
          html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
        });
      },
      screenLogoErrCb(errList) {
        this.showCbError();
      },
      getEventDatetime(datetime) {
        return moment(datetime).format('YYYY-MM-DD HH:mm');
      },
      updateSkybox_is_custom(e) {
          this.setSkybox_is_custom(e.target.checked);
      },
      updateEnvironment_is_custom(e) {
          this.setEnvironment_is_custom(e.target.checked);
      },
      removeSkyboxPicture(e) {
          this.setSkyboxPicture(null);
      },
      removeEnvironmentPicture(e) {
          this.setEnvironmentPicture(null);
      },
      updateSkyboxPicture(info,data) {
          if (!_.has(data, 'data.key')) {
              return;
          }
          const extension     = data.data.key.split('.').pop();
          const key           = _.get(this.item.skybox_picture, 'key', null);
          const size          = _.get(info, 'file.size', 0);
          this.setSkyboxPicture({
              old_key     : data.data.key,
              key         : data.data.key,
              temp_key    : info.id,
              size        : size.toString(),
              extension   : extension,
              uploadedBy  : info.user.first_name + ' ' + info.user.last_name,
              uploadedAt  : '2023.01.01',
          });
      },
      updateEnvironmentPicture(info, data) {
          if (!_.has(data, 'data.key')) {
              return;
          }
          const extension = data.data.key.split('.').pop();
          const key       = _.get(this.item.environment_picture, 'key', null);
          const size      = _.get(info, 'file.size', 0);
          this.setEnvironmentPicture({
              old_key     : data.data.key,
              key         : data.data.key,
              temp_key    : info.id,
              size        : size.toString(),
              extension   : extension,
              uploadedBy  :  info.user.first_name + ' ' + info.user.last_name,
              uploadedAt  : '2023.01.01',
          });
      },
      updateSkybox(e) {
          this.setSkybox(e.target.value);
      },
      updateEnvironment(e) {
          this.setEnvironment(e.target.value);
      },
      async updateDocuments(e){
          try {
              let image_qty   = 2; 
              
              let totalDocs = this.item.presentation_documents.length + e.target.files.length;
              if (totalDocs > image_qty) {
                  alert(`You can not upload more than ${image_qty} documents in the display center`);
                  return;
              }
              let pdfSize = this.getFileSizeConfigurationDocument();
              const files = e.target.files;
              for(let file of files){
                  let file_size = file.size;
                  let img_ext = file.name.split('.').pop().toLowerCase();
                  
                  if(['pdf'].includes(img_ext) ==false){
                      this.errCb();
                      return;
                  }
                  if(file_size>pdfSize){
                      this.showCbError();
                      return;
                  }
                  
              }
              const user = JSON.parse(localStorage.getItem('user'));
              for(let file of files){
                  let file_size = file.size;
                  let id = ObjectID();
                  let resp = await upload(file, id, "demo-space", null, 'documents');
                  let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                  let extension = fileKey.split('.').pop();

                  this.setDocument({
                      key: fileKey,
                      old_key: fileKey,
                      temp_key: id,
                      size: file_size.toString(),
                      extension: extension,
                      uploadedBy: user.first_name + ' ' + user.last_name,
                      uploadedAt: '2023.01.01',
                  });
              }
              
          } catch (e) {
              console.log("Error in set",e);
              this.$flashMessage.show({
              group: 'demo_space_edit',
              type: 'error',
              title: 'Error',
              html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
              });
          }
      },
      removeDocumentAsset(e, id) {
          console.log("removeid",id);
          this.$swal({
              title: "Are you sure ? ",
              text: "To fully delete the file submit the form.",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Delete",
              confirmButtonColor: "#dd4b39",
              focusCancel: true,
              reverseButtons: true
          }).then(result => {
              if (typeof result.dismiss === "undefined") {
                  remove(id).then(() => {
                  this.removeDocument(id);
                  })
              }
          });
      },
      async updateVerticalBanner(e){
          try {
              let image_qty = 10;
              let totalDocs = this.item.vertical_banners.length + e.target.files.length;
              if (totalDocs > image_qty) {
                  alert(`You can not upload more than ${image_qty} documents in the round table`);
                  return;
              }
            
              const files = e.target.files;
              for(let file of files){
                  let file_size = file.size;
                      let img_ext = file.name.split('.').pop().toLowerCase();
                      if(['jpg','jpeg'].includes(img_ext) ==false){
                          this.errCb();
                          return;
                      }
                  
              }
              const user = JSON.parse(localStorage.getItem('user'));
              for(let file of files){
                  let file_size = file.size;
                  let id = ObjectID();
                  let resp = await upload(file, id, "demo-space", '720X1800', 'banners');
                  let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                  let extension = fileKey.split('.').pop();

                  this.setVerticalBanner({
                      key: fileKey,
                      old_key: fileKey,
                      temp_key: id,
                      size: file_size.toString(),
                      extension: extension,
                      uploadedBy: user.first_name + ' ' + user.last_name,
                      uploadedAt: '2023.01.01',

                      
                  });
              }
              
          } catch (e) {
                  console.log("Error in set",e);
                  this.$flashMessage.show({
                  group: 'demo_space_edit',
                  type: 'error',
                  title: 'Error',
                  html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                  });
              }
      }, 
      removeVerticalBannerAsset(e, id) {
          console.log("removeid",id);
          this.$swal({
              title: "Are you sure ? ",
              text: "To fully delete the file submit the form.",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Delete",
              confirmButtonColor: "#dd4b39",
              focusCancel: true,
              reverseButtons: true
          }).then(result => {
              if (typeof result.dismiss === "undefined") {
                  remove(id).then(() => {
                  this.removeVerticalBanner(id);
                  })
              }
          });
      }, 
      getFileSizeConfigurationDocument(){
        console.log("this.eventItem.max_document_size",this.eventItem.max_document_size,"this.projectConfiguration.max_document_size",this.projectConfiguration.max_document_size);
          if(this.eventItem.max_document_size && this.eventItem.max_document_size>0){
              return this.eventItem.max_document_size
          }
          return this.projectConfiguration.max_document_size
      },
      getFileSizeConfigurationVideo(){
          if(this.eventItem.max_video_size && this.eventItem.max_video_size>0){
              return this.eventItem.max_video_size
          }
          return this.projectConfiguration.max_video_size
      },
      showVideoError(e) {
          this.$flashMessage.show({
              group: 'demo_space_edit',
              type: 'error',
              title: 'Error Invalid File Format',
              html  : "<ul><li>Uploaded video should be less than 10 MB.</li></ul>"
          });
      },
      updateModel1(info, data) {
          const key = _.get(this.item.model1, 'key', null);
          const size = _.get(info, 'file.size', 0); // size in bytes
          console.log("2:--Checking FBX size ********size", size);

          const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
          if (size > maxSize) {
              this.showVideoError();
              return; // stop further processing
          }

          let fileKey = data.data.key ? data.data.key : data.data.Key;
          const extension = fileKey.split('.').pop();
          // FBX file type validation
          // Get the original file type from the uploaded file
          const originalFileType = info.file.type.toLowerCase();
          const fileName = info.file.name.toLowerCase();
          
          // Check if extension is FBX and MIME type is appropriate
          let img_ext = fileName.split('.').pop().toLowerCase();
          console.log("Image Extension====>",img_ext)
          if(['fbx'].includes(img_ext) ==false){
                this.errCb();
              return;
                              
          }
          this.setModel1({
              old_key: fileKey,
              key: fileKey,
              temp_key: info.id,
              size: size.toString(),
              extension: extension,
              uploadedBy: info.user.first_name + ' ' + info.user.last_name,
              uploadedAt: '2023.01.01',
          });
      },
      updateModel2(info, data) {
          const key = _.get(this.item.model2, 'key', null);
          const size = _.get(info, 'file.size', 0); // size in bytes
          console.log("2:--Checking FBX size ********size", size);

          const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
          if (size > maxSize) {
              this.showVideoError();
              return; // stop further processing
          }

          let fileKey = data.data.key ? data.data.key : data.data.Key;
          const extension = fileKey.split('.').pop();

          const fileName = info.file.name.toLowerCase();
          
          if(['fbx'].includes(extension) ==false){
                this.errCb();
              return;
                              
          }

          this.setModel2({
              old_key: fileKey,
              key: fileKey,
              temp_key: info.id,
              size: size.toString(),
              extension: extension,
              uploadedBy: info.user.first_name + ' ' + info.user.last_name,
              uploadedAt: '2023.01.01',
          });
      },
      removeModel1(e) {
        this.setModel1(null);
      },
      removeModel2(e) {
        this.setModel2(null);
      },
      async updateModels(e) {
              try {
                  // Reset upload state
                  this.resetUploadState();
                  
                  let image_qty = 100;
                  let totalDocs = this.item.models.length + e.target.files.length;
                  
                  if (totalDocs > image_qty) {
                      alert(`You cannot upload 3D models more than ${image_qty} in the demo space`);
                      return;
                  }
                  
                  const files = Array.from(e.target.files);
                  this.totalFilesToUpload = files.length;
                  
                  // Calculate total size
                  this.totalSize = files.reduce((total, file) => total + file.size, 0);
                  
                  // Validate all files first
                  for (let file of files) {
                      let file_size = file.size;
                      let img_ext = file.name.split('.').pop().toLowerCase();
                      
                      if (!['fbx'].includes(img_ext)) {
                          this.errCb();
                          return;
                      }
                      
                      const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
                      if (file_size > maxSize) {
                          this.showVideoError();
                          return;
                      }
                  }
                  
                  // Start upload
                  this.isUploadingModels = true;
                  
                  const user = JSON.parse(localStorage.getItem('user'));
                  
                  // Upload files sequentially with progress tracking
                  for (let i = 0; i < files.length; i++) {
                          try {
                              const file = files[i];
                              this.currentUploadIndex = i;
                              
                              // Create form data for this file
                              
                              // Upload with progress tracking
                              const config = {
                                  onUploadProgress: (progressEvent) => {
                                      const percentCompleted = Math.round(
                                          (progressEvent.loaded * 100) / progressEvent.total
                                      );
                                      
                                      // Calculate overall progress
                                      const fileProgress = percentCompleted / files.length;
                                      const previousFilesProgress = (i / files.length) * 100;
                                      this.uploadProgress = Math.min(
                                          previousFilesProgress + fileProgress,
                                          100
                                      );
                                      
                                      // Update uploaded size
                                      if (percentCompleted === 100) {
                                          this.uploadedSize += file.size;
                                      }
                                  }
                              };
                              
                              // Upload the file
                              const id = ObjectID();
                              let resp = await upload(file, id, "demo-space", null, 'demo-space');
                
                              
                              let fileKey = resp.data.data.key || resp.data.data.Key;
                              let extension = fileKey.split('.').pop();
                              
                              // Add to models array
                              this.setModels({
                                  key: fileKey,
                                  old_key: fileKey,
                                  temp_key: id,
                                  size: file.size.toString(),
                                  extension: extension,
                                  uploadedBy: user.first_name + ' ' + user.last_name,
                                  uploadedAt: new Date().toISOString(),
                              });
                              
                          } catch (error) {
                              
                              console.error('Upload error:', error);
                              this.$flashMessage.show({
                                  group: 'demo_space_edit',
                                  type: 'error',
                                  title: 'Upload Failed',
                                  text: 'Failed to upload file: ' + error.message
                              });
                              
                              break;
                          }
                      }
                  
                  
                  // Reset upload state
                  this.resetUploadState();
                  this.$refs.modelsInput.value = ''; // Clear file input
                  
                  // Show success message
                  if (files.length > 0) {
                      this.$flashMessage.show({
                          group: 'demo_space_edit',
                          type: 'success',
                          title: 'Upload Complete',
                          text: `Successfully uploaded ${files.length} model(s)`
                      });
                  }
                  
              } catch (e) {
                  console.log("Error in set", e);
                  this.resetUploadState();
                  this.$flashMessage.show({
                      group: 'demo_space_edit',
                      type: 'error',
                      title: 'Error',
                      html: "<ul><li>Invalid File/Doc format. Please use described valid format</li></ul>"
                  });
              }
      }, 
      removeModelsAsset(e, id) {
          console.log("removeid",id);
          this.$swal({
              title: "Are you sure ? ",
              text: "To fully delete the file submit the form.",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Delete",
              confirmButtonColor: "#dd4b39",
              focusCancel: true,
              reverseButtons: true
          }).then(result => {
              if (typeof result.dismiss === "undefined") {
                  remove(id).then(() => {
                        this.removeModels(id);
                  })
              }
          });
      },
      resetUploadState() {
          this.isUploadingModels = false;
          this.uploadProgress = 0;
          this.currentUploadIndex = 0;
          this.totalFilesToUpload = 0;
          this.uploadedSize = 0;
          this.totalSize = 0;
          this.uploadCancelToken = null;
      },


      // Update the showVideoError method to be more generic
      showFileSizeError() {
          this.$flashMessage.show({
              group: 'demo_space_edit',
              type: 'error',
              title: 'Error: File Too Large',
              html: "<ul><li>Uploaded file should be less than 10 MB.</li></ul>"
          });
      },
      addNewModelSet() {
        this.addModelSet({
            model: null,
            icon: null,
            name: ''
        });
      },
    
      // Remove model set
      removeModelSet(index) {
          this.$swal({
              title: "Are you sure?",
              text: "This will remove the entire model set including both model and icon.",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Delete",
              confirmButtonColor: "#dd4b39",
              focusCancel: true,
              reverseButtons: true
          }).then(result => {
              if (result.value) {
                  this.removeModelSet(index);
              }
          });
      },
      
      // Update model file
      async updateModelFile(event, index) {
          const file = event.target.files[0];
          if (!file) return;
          
          // Validate file
          const fileName = file.name.toLowerCase();
          const fileExtension = fileName.split('.').pop();
          const maxSize = 10 * 1024 * 1024; // 10MB
          
          if (!['fbx'].includes(fileExtension)) {
              this.errCb();
              event.target.value = '';
              return;
          }
          
          if (file.size > maxSize) {
              this.showFileSizeError();
              event.target.value = '';
              return;
          }
          
          try {
              const user = JSON.parse(localStorage.getItem('user'));
              const id = ObjectID();
              
              // Set uploading state
              this.isUploadingModels = true;
              this.uploadProgress = 0;
              
              // Upload file
              const resp = await upload(file, id, "demo-space", null, '3d-models');
              const fileKey = resp.data.data.key || resp.data.data.Key;
              
              // Update model in set
              this.updateModelInSet({
                  index,
                  model: {
                      key: fileKey,
                      old_key: fileKey,
                      temp_key: this.item._id,
                      size: file.size.toString(),
                      extension: fileExtension,
                      uploadedBy: `${user.first_name} ${user.last_name}`,
                      uploadedAt: new Date().toISOString(),
                  }
              });
              
              // Reset input
              event.target.value = '';
              this.isUploadingModels = false;
              
              this.$flashMessage.show({
                  group : 'demo_space_edit',
                  type  : 'success',
                  title : 'Success',
                  time  : 1000,
                  html  : '<ul><li>3D model uploaded successfully</li></ul>'
              });
              
          } catch (error) {
              console.error('Error uploading model:', error);
              this.isUploadingModels = false;
              event.target.value = '';
              
              this.$flashMessage.show({
                  group: 'demo_space_edit',
                  type: 'error',
                  title: 'Upload Failed',
                  html: '<ul><li>Failed to upload 3D model</li></ul>'
              });
          }
      },
    
      // Update icon file
      async updateIconFile(event, index) {
          const file = event.target.files[0];
          if (!file) return;
          
          // Validate image file
          const fileName = file.name.toLowerCase();
          const fileExtension = fileName.split('.').pop();
          const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg'];
          const maxSize = 5 * 1024 * 1024; // 5MB for icons
          
          if (!allowedExtensions.includes(fileExtension)) {
              this.$flashMessage.show({
                  group: 'demo_space_edit',
                  type: 'error',
                  title: 'Invalid Format',
                  text: 'Icon must be an image file (JPG, PNG, GIF, SVG)'
              });
              event.target.value = '';
              return;
          }
          
          if (file.size > maxSize) {
              this.$flashMessage.show({
                  group: 'demo_space_edit',
                  type: 'error',
                  title: 'File Too Large',
                  text: 'Icon file should be less than 5MB'
              });
              event.target.value = '';
              return;
          }
          
          try {
              const user = JSON.parse(localStorage.getItem('user'));
              const id = ObjectID();
              
              // Set uploading state
              this.isUploadingModels = true;
              this.uploadProgress = 50;
              
              // Upload file
              const resp = await upload(file, id, "demo-space", '100X100', 'icons');
              const fileKey = resp.data.data.key || resp.data.data.Key;
              
              // Update icon in set
              this.updateIconInSet({
                  index,
                  icon: {
                      key: fileKey,
                      old_key: fileKey,
                      temp_key: this.item._id,
                      size: file.size.toString(),
                      extension: fileExtension,
                      uploadedBy: `${user.first_name} ${user.last_name}`,
                      uploadedAt: new Date().toISOString(),
                  }
              });
              
              // Reset input
              event.target.value = '';
              this.isUploadingModels = false;
              this.uploadProgress = 0;
              
              this.$flashMessage.show({
                  group : 'demo_space_edit',
                  type  : 'success',
                  title : 'Success',
                  time  : 1000,
                  html  : '<ul><li>Icon uploaded successfully</li></ul>'
              });
              
          } catch (error) {
              console.error('Error uploading icon:', error);
              this.isUploadingModels = false;
              this.uploadProgress = 0;
              event.target.value = '';
              
              this.$flashMessage.show({
                  group: 'demo_space_edit',
                  type: 'error',
                  title: 'Upload Failed',
                  html: '<ul><li>Failed to upload icon</li></ul>'
              });
          }

      },
      UpdateHasSketchRoom(e){
        this.setHasSketchRoom(e.target.checked);
      },
      
      // Remove model file
      removeModelFile(index) {
          this.$swal({
              title: "Are you sure?",
              text: "This will remove the 3D model file",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Delete",
              confirmButtonColor: "#dd4b39",
              focusCancel: true,
              reverseButtons: true
          }).then(result => {
              if (result.value) {
                  const modelSet = this.item.modelSets[index];
                  if (modelSet.model && modelSet.model.key) {
                      remove(modelSet.model.key).then(() => {
                          this.updateModelInSet({ index, model: null });
                      });
                  }
              }
          });
      },
      
      // Remove icon file
      removeIconFile(index) {
          this.$swal({
              title: "Are you sure?",
              text: "This will remove the icon file",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Delete",
              confirmButtonColor: "#dd4b39",
              focusCancel: true,
              reverseButtons: true
          }).then(result => {
              if (result.value) {
                  const modelSet = this.item.modelSets[index];
                  if (modelSet.icon && modelSet.icon.key) {
                      remove(modelSet.icon.key).then(() => {
                          this.updateIconInSet({ index, icon: null });
                      });
                  }
              }
          });
      },
      
      // Update model set name
      updateModelSetName(index) {
          // This will automatically update through v-model binding
          // If you need to track changes, add a specific action
          const modelSet = this.item.modelSets[index];
          this.updateModelSetName({ index, name: modelSet.name });
      },
      
      // Helper methods
      getUploadedModelsCount() {
          if (!this.item.modelSets) return 0;
          return this.item.modelSets.filter(set => set.model).length;
      },
      
      getUploadedIconsCount() {
          if (!this.item.modelSets) return 0;
          return this.item.modelSets.filter(set => set.icon).length;
      },
      
      getTotalModelsSize() {
          if (!this.item.modelSets) return 0;
          return this.item.modelSets.reduce((total, set) => {
              const modelSize = set.model ? parseInt(set.model.size || 0) : 0;
              const iconSize = set.icon ? parseInt(set.icon.size || 0) : 0;
              return total + modelSize + iconSize;
          }, 0);
      },
      
      // Cancel upload
      cancelUpload() {
          this.isUploadingModels = false;
          this.uploadProgress = 0;
          this.currentUploadIndex = 0;
          this.totalFilesToUpload = 0;
          this.uploadedSize = 0;
          this.totalSize = 0;
      }


  },
}
</script>

<style lang="scss" scoped>
.event_detail_wrapper {
  border-bottom: 0px solid #ccc;
  padding: 10px 0px;

  .event_ls_label {
    font-weight: bold;
  }
}

.setting_wrapper {
  float: right;

  a {
    color: #201e1eba;
    padding: 9px;
    margin-left: 5px;
    background: #c0cdd345;
    border-radius: 4px;
    border: 1px solid #80808054;
  }
}

.toggle label {
  color: #000 !important;
}

.drop-files {
  margin-top: 10px;
}

.newspeaker {
  margin-top: 20px;
}

.newspeaker button {
  width: 100%;
}

.add_spk_btn {
  background-color: #0088CC;
  color: #fff;
}

.mini_txt {
  font-size: 0.8em;
  color: #585252;
  font-style: italic;
  margin-bottom: 10px;
}

.v-dialog>.v-overlay__content>.v-card {
  border-radius: 15px;
  padding-top: 20px;
}

.tabs-left .nav-tabs>li .active {
  border-left-color: #0088CC;
}

.orangebtn {
  background-color: orange;
}

.wrapp {
  display: block;
  text-align: center;
  margin-bottom: 10px;
}

.surveytitlehd {
    background: #0088CC;
    color: #fff;
    border-radius: 5px;
    margin-bottom: 20px;
    padding: 10px;
}

.surveytitlehd label {
    color: #fff !important;
    font-weight: bold
}

.surveytitlehd span {
    margin-left: 20px;
}

.question_wrapper {
    background: #efefef;
    padding: 20px;
    margin-bottom: 15px;
    position: relative;
}

.question {
    font-weight: bold;
    margin-bottom: 10px;
}

.question_action {
    position: absolute;
    top: 50%;
    right: 50px;
}

.question_edit {
    background: #1896e3;
    color: #fff;
    padding: 8px 20px;
    border-radius: 5px;
    text-decoration: none;
    margin-right: 5px;
    box-shadow: 0px 1px 2px 0px #999;
    cursor: pointer;
}

.question_delete {
    background: #fff;
    color: #5a5757;
    padding: 8px 20px;
    border-radius: 5px;
    text-decoration: none;
    box-shadow: 0px 1px 2px 0px #999;
    cursor: pointer;

}

.newbtn {
    border: 1px solid #cccccc;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    margin-right: 5px;
}
/* Progress bar styling */
.progress {
    background-color: #e9ecef;
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    background-color: #007bff;
    transition: width 0.3s ease;
}

/* File item styling */
.image-item {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 10px;
    background-color: #f8f9fa;
}

.image-details {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;
}

.image-name {
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-size {
    color: #6c757d;
    font-size: 12px;
    margin: 0 10px;
}

.remove-btn {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 3px 8px;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
}

.remove-btn:hover {
    background-color: #c82333;
}

/* Upload summary */
.alert-info {
    background-color: #d1ecf1;
    border-color: #bee5eb;
    color: #0c5460;
}
.image-item {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 250px!important;
}

.image-item img {
  width: 100px !important;
  height: 60px !important;
  object-fit: cover;
  border-radius: 5px;
}
</style>